import React from 'react';
import { Link } from 'react-router-dom';
import expnd_collps_btn from '../../../assets/images/icons/user-dashboard/dashboard-expnd-collps-icon.png';
import user_no_image from '../../../assets/images/user-no-image.jpg'; 
import dashboard_icon from '../../../assets/images/icons/user-dashboard/dashboard-icon.png';
import dashboard_blue_icon from '../../../assets/images/icons/user-dashboard/dashboard-blue-icon.png';
import find_job_icon from '../../../assets/images/icons/user-dashboard/find-job-icon.png';
import find_job_blue_icon from '../../../assets/images/icons/user-dashboard/find-job-blue-icon.png';
import applied_job_icon from '../../../assets/images/icons/user-dashboard/appled-job-icon.png';
import applied_job_blue_icon from '../../../assets/images/icons/user-dashboard/appled-job-blue-icon.png';
import accepted_job_icon from '../../../assets/images/icons/user-dashboard/accpt-job-icon.png';
import accepted_job_blue_icon from '../../../assets/images/icons/user-dashboard/accpt-job-blue-icon.png';
import my_wishlist_icon from '../../../assets/images/icons/user-dashboard/wishlist-icon.png';
import my_wishlist_blue_icon from '../../../assets/images/icons/user-dashboard/wishlist-blue-icon.png';
import logout_icon from '../../../assets/images/icons/user-dashboard/logout-icon.png';
import logout_blue_icon from '../../../assets/images/icons/user-dashboard/logout-blue-icon.png';


const SideHeaderView = (props) => {
    console.log("PROFIle-pic",props.profile_picture);
    return (
        <>


            <div className={props.user_dashboard_left_sidebar}>
                <Link className="expnd-collps-btn" onClick={props.collaps_sidebar}><img src={expnd_collps_btn} /></Link>
               
            <div className="user-profile-area ">
                {/* <a href="/registrations/form4"> */}
                <div className="user-profile-image-wrap">
                    <div className="user-profile-image">
                        <img src={props.profile_picture ?props.profile_picture : user_no_image} alt="" />
                        
                    </div>
                </div>
                {/* </a> */}
                <h3 className="user-name">{props.first_name} {props.last_name}</h3>
                <p className="user-sub-title">Clinical Nurse Manager at The Practice Group UK</p>
                <div className="user-sub-title user-profile-actn-area ">
                        <a href="/registrations/form4" ><button type="button" className="btn btn-border bold update-profile-btn"><i className="fa fa-pencil-square-o " aria-hidden="true"></i> <span>update profile</span></button></a>
                        <Link className="user-bell-btn"><i className="fa fa-bell" aria-hidden="true"></i><span className="notificatn-round-count">6</span></Link>
                </div>
            </div>
                <div className="dashboard-lft-menu">    
                    <ul>
                        <li className="">
                            <Link to="/dashboard">
                            <span className="icon">
                                    <img src={dashboard_icon} />
                                    <img src={dashboard_blue_icon} />
                            </span><span className="menuname">DASHBOARD</span>
                            </Link>
                        </li>
                        <li>
                            <Link to='/find-jobs'>
                            <span className="icon">
                                    <img src={find_job_icon} />
                                    <img src={find_job_blue_icon} />
                            </span><span className="menuname">FIND A JOB</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/dashboard/pending-job">
                                <span className="icon">
                                    <img src={applied_job_icon} />
                                    <img src={applied_job_blue_icon} />
                                </span><span className="menuname">PENDING JOBS</span>
                                <span className=" notificatn-round-count">{props.pending_jobs_count}</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/dashboard/accepted-job">
                                <span className="icon">
                                    <img src={accepted_job_icon} />
                                    <img src={applied_job_blue_icon} />
                                </span><span className="menuname">ACCEPTED JOBS</span>
                                <span className=" notificatn-round-count">{props.accepted_jobs_count}</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/dashboard/wish-list">
                                <span className="icon">
                                    <img src={my_wishlist_icon} />
                                    <img src={my_wishlist_blue_icon} />
                                </span><span className="menuname">MY FAVOURITES</span>
                                <span className=" notificatn-round-count">{props.wishlist_count}</span>
                            </Link>
                        </li>
                        <li className="logout" onClick={props.handlelogout}>
                            <Link to="/login">
                                <span className="icon">
                                    <img  src={logout_icon} />
                                    <img src={logout_blue_icon} />
                                </span><span className="menuname">LOG OUT</span>
                            </Link>
                        </li>
                    </ul>
                </div>
        </div>
        </>
    )
}

export default SideHeaderView;